<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>活动详情</h1>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page bg-white">
      <div id="myIframe">
      </div>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'

export default {
  data () {
    return {
      windowHeight: 0,
      activityId: 0,
      get_activity_info_para: service.setPara('getActivityInfo'),
      activityInfo: {}
    }
  },
  mounted: function () {
    if (this.activityId != this.$route.params.activityId) {
      this.activityId = this.$route.params.activityId
      $('#myIframe iframe').remove()
      this.getActivityInfo()
    }
  },
  methods: {
    getActivityInfo: function () {
      this.get_activity_info_para.activityId = this.activityId

      let that = this
      let obj = {context: this, para: this.get_activity_info_para, successFun: (response) => {
        that.activityInfo = response.data
        Vue.nextTick(function () {
          $('#myIframe').html('<iframe id="myIframe" width="100%" frameborder="0" height="' + $(window).height() + '" src="' + that.activityInfo.field2 + '?activityId=' + that.activityInfo.activityId + '"></iframe>')
        })
      }}
      service.request(obj)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ActivityInfo.vue?96e2439c